import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AmbassadorChallenge.less';
import './AmbassadorChallenge.css'
import moment from 'moment';

interface AmbassadorInitiativeBlockProps {
    data: InitiativeDataRecord;
}

interface FunctionsToProps {
    getConvertedCurrencyValue: (value: number) => string;
    getPercentageFunded: (currentValue: number, goalvalue: number) => number;
}

export const AmbassadorInitiativeBlock = (props: AmbassadorInitiativeBlockProps & FunctionsToProps) => {
    const {
        RaisedAmount,
        GoalAmount,
        FundraisingInitiativeName,
        FundraisingInitiativeDescription,
        InitiativeImage,
        InitiativeGoalType,
        NumberOfDonations,
        GoalParticipation,
        FundraisingInitiativeEndDate
    } = props.data;
    //getConvertedCurrencyValue
    const { getPercentageFunded } = props;
    const currentDate = moment();
    const endDate = moment(FundraisingInitiativeEndDate, "YYYY-MM-DD HH:mm:ss");

    const difference = moment.duration(endDate.diff(currentDate));
    const days = isNaN(difference.days()) ? 0 : difference.days();
    const hours = isNaN(difference.hours()) ? 0 : difference.hours();
    const minutes = isNaN(difference.minutes()) ? 0 : difference.minutes();
    let formattedDifference = (days != 0 && days > 0) ? `${days} day${days !== 1 ? 's' : ''} ${hours} hr${hours !== 1 ? 's' : ''} ${minutes} min` :
        ((hours != 0 && hours > 0) ? `${hours} hr${hours !== 1 ? 's' : ''} ${minutes} min` : ((minutes != 0 && minutes > 0) ? `${minutes} min` : "Fundraising Initiative has ended"));

    let percentageFunded = 0;
    if (InitiativeGoalType === 'Participation') {
        percentageFunded = getPercentageFunded(NumberOfDonations, GoalParticipation);
    } else {
        percentageFunded = getPercentageFunded(RaisedAmount, GoalAmount);
    }

    return (
        <div className="container initiative-card">
            <div className="row" style={{ marginLeft: "0px" }}>
                {InitiativeImage ? (
                    <div className="col-md-7 col-sm-12 text-center" style={{ padding: "0px" }}>
                        <div className="initiative-image-wrapper">
                            <img
                                data-test="campaignImage"
                                src={InitiativeImage || ''}
                                className="img-responsive initiative-image ratio ratio-16x9"
                                style={{ maxHeight: '500px', maxWidth: '100%' }}
                                alt={InitiativeImage ? 'Initiative cover' : 'Initiative cover not available'}
                            />
                        </div>

                    </div>
                ) : (<div className="col-md-7 col-sm-12 text-center mobile-initiative-image" style={{ backgroundColor: "#D9D9D9", padding: "0px" }}></div>)}
                <div className="col-md-5 col-sm-12 mobile-initiative-wrapper desktop-initiative-wrapper" style={{ height: '300px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div className="progress" style={{ height: '8px', backgroundColor: '#e9ecef', borderRadius: "unset" }}>
                        <div
                            className="progress-bar"
                            role="progressbar"
                            style={{ width: `${percentageFunded}%`, backgroundColor: '#198754' }}
                            aria-valuenow={percentageFunded}
                            aria-valuemin={0}
                            aria-valuemax={100}
                            aria-label={FundraisingInitiativeName + ' Initiative Fundraising Progress'}
                        ></div>
                    </div>
                    <div className="details-wrapper" style={{ display: "contents" }} >
                        <div className="detail-item" >
                            <div className="detail-value" style={{ fontSize: "x-large", fontWeight: "bolder" }} >${RaisedAmount}</div>
                            <div className="detail-label" style={{ fontSize: "12px", color: '#6c757d', marginTop: "0" }}>raised of ${GoalAmount} goal</div>
                        </div>
                        <div className="detail-item" >
                            <div className="detail-value" style={{ fontSize: "x-large", fontWeight: "bolder" }}>{NumberOfDonations}</div>
                            <div className="detail-label" style={{ fontSize: "12px", color: '#6c757d', marginTop: "0" }}>donors</div>
                        </div>
                        <div className="detail-item" >
                            <div className="detail-value" style={{ fontSize: "x-large", fontWeight: "bolder" }}>{formattedDifference}</div>
                            {formattedDifference === "Fundraising Initiative has ended" ? (<div></div>) : <div className="detail-label" style={{ fontSize: "12px", color: '#6c757d', marginTop: "0" }}>remaining</div>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row" style={{ marginTop: '20px' }}>
                <div className="col-md-12">
                    <p className="detail-description" style={{ fontSize: '12px', color: '#212529', marginTop: '15px', textAlign: "justify" }}>{FundraisingInitiativeDescription}</p>
                </div>
            </div>
        </div>
    );
};
